import React from "react";

import { surmountAIQFV2 } from "assets/icons";
import { ModalHeaderContainer } from "./ModalHeader.styles";

const RecommendedModalHeader = () => {
  return (
    <ModalHeaderContainer>
      <div className="text-center heading">
        <img src={surmountAIQFV2} alt="Surmount AI QF logo" />
      </div>
    </ModalHeaderContainer>
  );
};

export default RecommendedModalHeader;
